

import * as actionTypes from '../actions';
import store from 'store';
import { architeckCall } from 'database';

export const updateUsers = (objects) => {

    let objectsToUpdate = objects

    // //if no array is sent create an array out of single _id sent
    if(!(objects instanceof Array)) {
        objectsToUpdate = [objects]
    }

    let newStateToSet = [...store.getState().users.app_users]

    objectsToUpdate.forEach(u => {

        newStateToSet[newStateToSet.findIndex(el => el._id === u._id)] = u;

    })

    dispatchActions(newStateToSet)
    
}

export const removeUsers = (_ids) => {

    let objectsToRemove = _ids

    //if no array is sent create an array out of single _id sent
    if(!(_ids instanceof Array)) {
        objectsToRemove = [_ids]
    }

    let newStateToSet = [...store.getState().users.app_users]

    newStateToSet = newStateToSet.filter(u => {
        return objectsToRemove.includes(u._id) ? false: true
    })
   
    dispatchActions(newStateToSet)
   
}

export const addUsers = (objects) => {

    let objectsToUpdate = objects

    // //if no array is sent create an array out of single _id sent
    if(!(objects instanceof Array)) {
        objectsToUpdate = [objects]
    }

    let newStateToSet = [...store.getState().users.app_users]

    objectsToUpdate.forEach(u => {

        newStateToSet.unshift(u);

    })

    dispatchActions(newStateToSet)
    
}

export const setAppUsers = async() => {
    return new Promise( async (resolve, reject) => {

        const users = await architeckCall({
            method: 'get',
            url: '/api/v1/users/list?loop=true&limit=500'
        })

        if(users.success) {

            dispatchActions(users.data)

            resolve({success: true});
            return;

        } else {

            //error reporting here
            resolve({success: false, message: 'Failed to load app users. '});
            return;

        }

    })

}

const dispatchActions = (user_data) => {

    store.dispatch({
        type: actionTypes.SET_APP_USERS,
        payload: {
            objects: user_data
        }
    });

    store.dispatch({
        type: actionTypes.SET_APP_USERS_THIS_WEEK,
        payload: {
            objects: user_data.filter(o =>   o.created_at > ((new Date()).getTime() / 1000) - (7 * 86400) )
        }
    });

    store.dispatch({
        type: actionTypes.SET_APP_ADMINS,
        payload: {
            objects: user_data.filter(o => o.is_admin)
        }
    });

    store.dispatch({
        type: actionTypes.SET_APP_DEVELOPERS,
        payload: {
            objects: user_data.filter(o => o.is_dev)
        }
    });

    return true;
}